'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupSanitize = undefined;

var _Sanitize = require('Sanitize');

var _Sanitize2 = _interopRequireDefault(_Sanitize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupSanitize = exports.setupSanitize = function setupSanitize() {
  if (!_Sanitize2.default.Config) {
    _Sanitize2.default.Config = {};
  }

  _Sanitize2.default.Config.RELAXED = {
    elements: ['a', 'b', 'blockquote', 'br', 'caption', 'cite', 'code', 'col', 'colgroup', 'dd', 'dl', 'dt', 'em', 'figure', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'i', 'li', 'ol', 'p', 'pre', 'q', 'small', 'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'u', 'ul', 'font', 'div', 'span'],

    attributes: {
      __ALL__: ['style'],
      a: ['href', 'title', 'target'],
      blockquote: ['cite'],
      col: ['span', 'width'],
      colgroup: ['span', 'width'],
      figure: ['style'],
      ol: ['start', 'type'],
      q: ['cite'],
      table: ['summary', 'width'],
      td: ['abbr', 'axis', 'colspan', 'rowspan', 'width'],
      th: ['abbr', 'axis', 'colspan', 'rowspan', 'scope', 'width'],
      ul: ['type'],
      font: ['size'],
      span: ['data-at-mention', 'data-owner-id', 'contenteditable']
    },

    add_attributes: {
      a: { rel: 'nofollow noopener noreferrer' }
    },

    protocols: {
      a: { href: ['ftp', 'http', 'https', 'mailto', _Sanitize2.default.RELATIVE] },
      blockquote: { cite: ['http', 'https', _Sanitize2.default.RELATIVE] },
      img: { src: ['http', 'https', _Sanitize2.default.RELATIVE] },
      q: { cite: ['http', 'https', _Sanitize2.default.RELATIVE] }
    },
    remove_contents: ['style', 'script']
  };

  return _Sanitize2.default;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/sanitize/relaxed.js
// module id = 307
// module chunks = 0 1